import React, { useContext, useEffect } from "react";
import apiCalls from "shared/utils/apiCalls";
import AppContext from "context/AppContext";
import { Link } from "react-router-dom";
import { ReducerTypes } from "shared/types/reducerTypes";
import styles from "./Notifications.module.scss";
import { Notification, NotificationTypes } from "shared/types/notification";
import moment from "moment";
import getBadge from "shared/utils/getBadge";
import Badge from "shared/components/Badge/Badge";

const Notifications = () => {
  const { state, dispatch } = useContext(AppContext);

  const seenNotifications = async () => {
    const res = await apiCalls({
      method: "post",
      url: `/notification/${state.notifications.id}/seen`,
    });

    if (res) {
      dispatch({
        type: ReducerTypes.seenNotifications,
      });
    }
  };

  useEffect(() => {
    const checkNotfication = async () => {
      await seenNotifications();
    };

    checkNotfication();

    // eslint-disable-next-line
  }, [state.notifications.id]);

  if (!state.notifications.notifications) {
    return (
      <div className={styles.notifications}>
        <h2
          style={{
            color: "var(--grey-5)",
          }}
        >
          No Notifications
        </h2>
      </div>
    );
  }

  return (
    <div className={styles.notifications}>
      <h2>Notifications</h2>
      {state.notifications.notifications.map((notification: Notification) => (
        <div
          className={styles.notifications_card}
          key={notification.updatedAt}
          style={{
            border: notification.seen
              ? "none"
              : "1px solid var(--primary-color-xlight)",
          }}
        >
          {notification.senderPicture ? (
            <Link
              className={styles.notifications_card_user}
              to={`/profile/${notification.userId}`}
            >
              <img
                src={notification.senderPicture}
                alt={notification.username}
              />
            </Link>
          ) : (
            <div className={styles.notifications_card_user}>
              <img
                src="https://firebasestorage.googleapis.com/v0/b/devchallenges-1234.appspot.com/o/logo_2.png?alt=media&token=a5155688-fbfa-4ece-b692-fe2326db7741"
                alt="devchallenges.io"
              />
            </div>
          )}

          <div className={styles.notifications_card_message}>
            <div className={styles.notifications_card_content}>
              {notification.username ? (
                <Link
                  className={styles.notifications_card_username}
                  to={`/profile/${notification.userId}`}
                >
                  {notification.username}
                </Link>
              ) : (
                <div className={styles.notifications_card_content}>
                  <div
                    className={styles.notifications_card_username}
                    style={{ color: "var(--grey-6)", cursor: "initial" }}
                  >
                    Devchallenges: You <b>earned</b> a new badge
                  </div>
                </div>
              )}

              {notification.type === NotificationTypes.badge && (
                <div style={{ marginBottom: "var(--space-sm)" }}>
                  {notification?.badgeName && (
                    <Badge
                      description={
                        getBadge(notification?.badgeName)?.description
                      }
                      type={getBadge(notification?.badgeName)?.type}
                      label={getBadge(notification?.badgeName)?.label}
                      category={getBadge(notification?.badgeName)?.category}
                    />
                  )}
                </div>
              )}

              {notification.type === NotificationTypes.feedback && (
                <p>
                  <b>gave</b> you a feedback on{" "}
                </p>
              )}

              {notification.type === NotificationTypes.like && (
                <p>
                  <b>liked</b> your solution -{" "}
                </p>
              )}

              {notification.type === NotificationTypes.reply && (
                <p>
                  <b>replied</b> your feedback on{" "}
                </p>
              )}

              {notification.solutionTitle && (
                <Link
                  className={styles.notifications_card_solution}
                  to={`/solutions/${notification.solutionId}`}
                >
                  {notification.solutionTitle}
                </Link>
              )}
            </div>

            <p
              style={{
                fontSize: "var(--text-xs)",
                fontWeight: "normal",
                fontFamily: "var(--heading-font-family)",
                display: "inline-block",
                marginBottom: 0,
                color: "var(--grey-5)",
              }}
            >
              {moment(notification.updatedAt).toNow()}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Notifications;
